<template>
  <div class="podium">
    <table id="ladder">
      <tr>

        <td class="podium-class">
          <img
            class="rounded-circle avatar-md m-auto d-flex"
            alt="100x100"
            src="@/assets/images/users/avatar-5.jpg"
            data-holder-rendered="true"
          />
          <div id="podium5" class="d-flex justify-content-center align-self-end align-items-end">
            <h5>5°</h5>
          </div>
        </td>

        <td class="podium-class">
          <img
            class="rounded-circle avatar-md m-auto d-flex"
            alt="100x100"
            src="@/assets/images/users/avatar-3.jpg"
            data-holder-rendered="true"
          />
          <div id="podium3" class="d-flex justify-content-center align-self-end align-items-end">
            <h5>3°</h5>
          </div>
        </td>

        <td class="podium-class">          
          <img
            class="rounded-circle avatar-md m-auto d-flex"
            alt="100x100"
            src="@/assets/images/users/avatar-1.jpg"
            data-holder-rendered="true"
          />
          <div id="podium1" class="d-flex justify-content-center align-self-end align-items-end">
            <h5>1°</h5>
          </div>
        </td>
        <td class="podium-class">
          <img
            class="rounded-circle avatar-md m-auto d-flex"
            alt="100x100"
            src="@/assets/images/users/avatar-2.jpg"
            data-holder-rendered="true"
          />
          <div id="podium2" class="d-flex justify-content-center align-self-end align-items-end">
            <h5>2°</h5>
          </div>
        </td>
        <td class="podium-class">
          <img
            class="rounded-circle avatar-md m-auto d-flex"
            alt="100x100"
            src="@/assets/images/users/avatar-4.jpg"
            data-holder-rendered="true"
          />
          <div id="podium4" class="d-flex justify-content-center align-self-end align-items-end">
            <h5>4°</h5>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>

export default {
    props: {
      listaRanking: Array,
  },
  data(){
    return {
      primeiro: "",
      segundo: "",
      terceiro: "",
      quarto: "",
      quinto: "",
    }
  },
  created(){
    if(this.listaRanking){
      console.log(this.listaRanking)
    }
  }
}
</script>


<style>
  .podium-class {
    height: 300px;
    vertical-align: bottom;
    padding: 5px;
  }
  #podium1, #podium2, #podium3, #podium4, #podium5 {
    width: 7rem;
    background-image: linear-gradient(to top, rgba(255,0,0,0), rgba(98,81,252,99));
    border-radius: 10px 10px 0px 0px;
  }
  #podium1 {
    height: 85%;
  }
  #podium1:hover {
    height: 90%;
  }
  #podium2 {
    height: 65%;
  }
  #podium2:hover {
    height: 75%;
  }
  #podium3 {
    height: 55%;
  }
  #podium3:hover {
    height: 65%;
  }
  #podium4 {
    height: 35%;
  }
  #podium4:hover {
    height: 45%;
  }
  #podium5 {
    height: 20%;
  }
  #podium5:hover {
    height: 30%;
  }
</style>
